import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { SearchFilterFilter } from '@app/search/search-api.model';
import { fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SubscriberBaseDirective } from '@app/shared/components/subscriber-base/subscriber-base.directive';

@Component({
  selector: 'dgx-search-filter-sidebar-range-options',
  templateUrl: './search-filter-sidebar-range-options.component.html',
  styleUrls: ['./search-filter-sidebar-range-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterSidebarRangeOptionsComponent
  extends SubscriberBaseDirective
  implements AfterViewInit
{
  @Input() public filter: SearchFilterFilter;
  @Output() public filtersChanged = new EventEmitter<SearchFilterFilter>();

  @ViewChild('minPriceInput') public minPriceRef: ElementRef;
  @ViewChild('maxPriceInput') public maxPriceRef: ElementRef;

  public get minFilter() {
    return this.filter.subitems.find((item) => item.model.config.isMinFilter);
  }

  public get maxFilter() {
    return this.filter.subitems.find((item) => item.model.config.isMaxFilter);
  }

  public get minCostValue() {
    return this.minFilter.model?.values[0]?.name || '';
  }
  public get maxCostValue() {
    return this.maxFilter.model?.values[0]?.name || '';
  }

  public ngAfterViewInit() {
    fromEvent(this.minPriceRef.nativeElement, 'keyup')
      .pipe(
        this.takeUntilDestroyed(),
        filter((e: KeyboardEvent) => e.key === 'Enter')
      )
      .subscribe(() => {
        this.priceChanged();
      });

    fromEvent(this.maxPriceRef.nativeElement, 'keyup')
      .pipe(
        this.takeUntilDestroyed(),
        filter((e: KeyboardEvent) => e.key === 'Enter')
      )
      .subscribe(() => {
        this.priceChanged();
      });
  }

  public priceChanged(): void {
    const minFilterValue = this.minPriceRef?.nativeElement?.value ?? '';
    const maxFilterValue = this.maxPriceRef?.nativeElement?.value ?? '';

    const subitems = [];
    for (const item of this.filter.subitems) {
      const value = item.model.config.isMinFilter
        ? minFilterValue
        : maxFilterValue;
      const model = { ...item.model, name: value };
      subitems.push({ ...item, model, isSelected: true });
    }
    this.filtersChanged.emit({ ...this.filter, subitems });
  }
}
